import React, { memo } from 'react';
import { Section } from './Section';
export function Features() {
  const features = [{
    icon: '📋',
    title: '+150 actividades en 23 temáticas',
    desc: 'Organizadas para trabajar memoria, atención, coordinación, percepción visual y razonamiento.'
  }, {
    icon: '✅',
    title: 'Instrucciones claras en cada ejercicio',
    desc: 'Lo abrís, leés y empezás. Sin manuales, sin explicaciones raras, sin vueltas.'
  }, {
    icon: '🎯',
    title: 'A tu ritmo, como a vos te guste',
    desc: 'Hacés las actividades que más te atraigan, cuando quieras y sin presiones. Nadie te apura.'
  }, {
    icon: '🖨️',
    title: 'PDF para imprimir o usar en pantalla',
    desc: 'Si preferís el papel, lo imprimís. Si preferís la tablet o la computadora, también funciona perfecto.'
  }, {
    icon: '♾️',
    title: 'Lo imprimís las veces que quieras',
    desc: 'Pagás una sola vez y lo usás todas las veces que necesites. También podés compartirlo con tu familia.'
  }];
  return <Section className="bg-cream" data-id="element-55">
      <div className="text-center mb-16" data-id="element-56">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-57">
          Por eso creamos el KIT MENTE CLARA & ACTIVA 🧠
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-58">
          El cuadernillo digital de gimnasia mental pensado especialmente para
          adultos. Para usar en tu casa, cuando vos quieras, sin apuros y sin
          depender de nadie.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-59">
        {features.map((feature, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex gap-4" data-id="element-60">
            <div className="text-4xl shrink-0" data-id="element-61">{feature.icon}</div>
            <div data-id="element-62">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-63">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-64">{feature.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="bg-blue-50 p-6 rounded-2xl flex gap-4 items-start border border-blue-100" data-id="element-65">
        <div className="text-3xl shrink-0" data-id="element-66">📐</div>
        <div data-id="element-67">
          <h4 className="font-bold text-blue-900 mb-1" data-id="element-68">
            Con respaldo científico
          </h4>
          <p className="text-blue-800 text-sm md:text-base leading-relaxed" data-id="element-69">
            Basado en Neuroplasticidad, Reserva Cognitiva, modelo de Sohlberg &
            Mateer y Gimnasia Cerebral de Paul Dennison. Son métodos probados,
            usados por profesionales en todo el mundo para ayudar a mantener el
            cerebro activo con los años.
          </p>
        </div>
      </div>
    </Section>;
}